/* True Alibi · fiches produit (pdp-v2-20260918)
 *
 * Chargé uniquement sur les fiches des quatre scénarios (snippets/ta-pdp.liquid).
 * 1. Libellé du bouton principal selon le format choisi, avec le prix de la
 *    variante formaté par Shopify (lu dans la configuration, jamais en dur).
 * 2. Événements dataLayer select_product_format et product_cta_click.
 *
 * Aucune donnée personnelle, aucun appel à GA4 ni à Google Ads, aucun cookie.
 * Le formulaire produit natif reste seul responsable de l'ajout au panier :
 * ce script n'empêche ni ne relance aucune soumission.
 */
(function () {
  'use strict';

  var configEl = document.getElementById('ta-pdp-config');
  if (!configEl) return;

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }

  var mainButton = document.querySelector('.main-product-atc[type="submit"]');
  if (!mainButton || !mainButton.form) return;

  var form = mainButton.form;
  var labelEl = mainButton.querySelector('.main-atc__label__text');
  var defaultLabel = (window.variantStrings && window.variantStrings.addToCart) || '';

  function currentVariantId() {
    var input = form.querySelector('input[name="id"]');
    return input ? String(input.value) : '';
  }

  function variantData(id) {
    return config.variants[String(id)] || null;
  }

  function formatOf(id) {
    var data = variantData(id);
    return data ? data.format : 'unknown';
  }

  function pushEvent(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  /* 1. Libellé dynamique du bouton ---------------------------------------- */

  function desiredLabel(id) {
    var data = variantData(id);
    if (!data || !data.cta) return defaultLabel;
    return data.cta + ' · ' + data.priceText;
  }

  // Même structure que le rendu serveur de buy-buttons.liquid : le prix
  // passe à la ligne sur mobile sans laisser de séparateur orphelin.
  function renderLabel(id) {
    var data = variantData(id);
    labelEl.textContent = '';
    if (!data || !data.cta) {
      labelEl.textContent = defaultLabel;
      return;
    }
    var sep = document.createElement('span');
    sep.className = 'ta-cta-sep';
    sep.textContent = ' · ';
    var price = document.createElement('span');
    price.className = 'ta-cta-price';
    price.textContent = data.priceText;
    labelEl.appendChild(document.createTextNode(data.cta));
    labelEl.appendChild(sep);
    labelEl.appendChild(price);
  }

  function applyLabel() {
    if (!labelEl || mainButton.disabled) return;
    var current = labelEl.textContent.trim();
    // Le thème réécrit le libellé à chaque changement de variante. On ne
    // remplace que son libellé standard ou le nôtre, jamais « Épuisé ».
    var ours = Object.keys(config.variants).map(function (key) {
      return desiredLabel(key);
    });
    if (current !== defaultLabel && ours.indexOf(current) === -1) return;
    var id = currentVariantId();
    if (current !== desiredLabel(id)) renderLabel(id);
  }

  if (labelEl && 'MutationObserver' in window) {
    new MutationObserver(applyLabel).observe(labelEl, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }
  applyLabel();

  /* 2a. select_product_format --------------------------------------------- */

  var lastVariantId = currentVariantId();
  var lastUserChange = 0;
  var lastPushed = '';

  // Seul un changement déclenché par l'utilisateur sur l'option de format
  // compte. Les changements programmatiques du thème ne sont pas « trusted ».
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!event.isTrusted || !target || target.type !== 'radio') return;
    if (!target.closest('variant-selects')) return;
    lastUserChange = Date.now();
  }, true);

  function onVariantChange(newId) {
    newId = String(newId || currentVariantId());
    var fromId = lastVariantId;
    lastVariantId = newId;
    applyLabel();

    if (!newId || newId === fromId) return;
    if (Date.now() - lastUserChange > 3000) return;

    var from = formatOf(fromId);
    var to = formatOf(newId);
    if (from === to) return;

    var key = fromId + '>' + newId + '@' + lastUserChange;
    if (key === lastPushed) return;
    lastPushed = key;

    var data = variantData(newId);
    pushEvent({
      event: 'select_product_format',
      from_format: from,
      to_format: to,
      variant_id: newId,
      price: data ? data.price : null,
      currency: config.currency,
      product_handle: config.handle,
      template_version: config.templateVersion
    });
  }

  if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
    window.subscribe(window.PUB_SUB_EVENTS.variantChange, function (payload) {
      var variant = payload && payload.data && payload.data.variant;
      onVariantChange(variant && variant.id);
    });
  } else if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    // main.js déclare ces globaux avec function / const : ils sont visibles
    // par leur nom mais pas toujours comme propriétés de window.
    subscribe(PUB_SUB_EVENTS.variantChange, function (payload) {
      var variant = payload && payload.data && payload.data.variant;
      onVariantChange(variant && variant.id);
    });
  } else {
    // Repli : lire la variante juste après le changement de l'utilisateur.
    document.addEventListener('change', function (event) {
      if (!event.isTrusted || !event.target.closest || !event.target.closest('variant-selects')) return;
      window.setTimeout(function () { onVariantChange(currentVariantId()); }, 0);
    });
  }

  /* 2b. product_cta_click ------------------------------------------------- */

  function ctaPayload(location) {
    var id = currentVariantId();
    var data = variantData(id);
    return {
      event: 'product_cta_click',
      cta_location: location,
      selected_format: formatOf(id),
      variant_id: id,
      price: data ? data.price : null,
      currency: config.currency,
      product_handle: config.handle,
      template_version: config.templateVersion
    };
  }

  mainButton.addEventListener('click', function (event) {
    if (!event.isTrusted || mainButton.disabled) return;
    pushEvent(ctaPayload('hero'));
  });

  // Phase de capture : le thème arrête la propagation du clic sur le bouton
  // de la barre collante, un écouteur en phase de bouillonnement ne le voit pas.
  var sticky = document.querySelector('sticky-atc');
  if (sticky) {
    sticky.addEventListener('click', function (event) {
      if (!event.isTrusted) return;
      var button = event.target.closest && event.target.closest('button');
      if (!button || !sticky.contains(button) || button.disabled) return;
      pushEvent(ctaPayload('sticky'));
    }, true);
  }
})();
